/* global $ */

import { Controller } from 'stimulus';

class Placeholder extends Controller {
  connect() {
    const $inputs = $(this.element).find('input[placeholder]');

    if ($inputs.length) {
      this.createPlaceholders($inputs);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  createPlaceholders($inputs) {
    $inputs.each((i, input) => {
      const $input = $(input);
      const placeholderText = $input.attr('placeholder');

      $input.after(`<span class="placeholder">${placeholderText}</span>`);
      $input.attr('placeholder', '');

      $input.toggleClass('active', $input.val() !== '');

      $input.on('focusout', () => {
        $input.toggleClass('active', $input.val() !== '');
      }).on('focus', () => {
        $input.addClass('active');
      });
    });
  }
}

Placeholder.targets = [
  //
];

export default Placeholder;
